import { Component, Input, AfterViewInit, ViewChild, ElementRef } from "@angular/core";
import { map } from 'rxjs/operators';
import { Viewport } from '../../../../../utils/viewport';
import { Col } from '../../../cols/col.class';
import { LocalTable } from '../table.class';
import { AbstractMenu } from '../../abstract/menu/menu.component';
import { Fade } from '../../../../../animations/animations';


@Component({
   selector: "exi-menu-local",
   template: `
      <div style="display: flex; justify-content: space-between;">
         <app-reseter [menu]="menu"></app-reseter>
         <div class="count">
            <div class="info filtred" title="Rows count after filtration">
               <span>{{ menu.filtred | async }}</span>
            </div>
               <div class="info all" title="Total Rows count">
                  <span>{{ menu.total | async  }}</span>
               </div>
         </div>
      </div>
      <app-global-filter [ctx]="menu.ctx"></app-global-filter>
      <section class="cols" #Cols>
         <div class="block">
            <app-col-control-local  *ngFor="let pair of pairs" 
                                    [col]="pair[0]" 
                                    [filter]="pair[1]"
                                    [ctx]="menu.ctx"></app-col-control-local>
         </div>
      </section>
   `,
   styleUrls: ["./menu.component.scss"],
   animations: [ Fade ]
})
export class LocalMenuComponent implements AfterViewInit {
   @Input() menu: LocalMenu;
   @ViewChild('Cols') colsList: ElementRef<HTMLDivElement>;
   public colsViewport: Viewport<any>;
   public pairs: Col<object>[] = [];

   constructor() { }

   ngAfterViewInit () {
      const { ctx } = this.menu;
      const colsList = this.colsList.nativeElement;
      const visible = ctx.rows.maxVisibleCount - 2;

      this.colsViewport = new Viewport(visible);
      this.colsViewport.setHost(colsList, ctx.rows.height);

      requestAnimationFrame(() => {
         this.pairs = this.colsViewport.build(Array.from(ctx.filter.byCol.entries()));
      });
   }
}

export class LocalMenu extends AbstractMenu<LocalTable<any>> {
   public component = LocalMenuComponent;

   constructor(ctx: LocalTable<any> ) {
      super('local', ctx, ctx.filter.output.pipe(
         map(rows => rows.length)
      ));
   }

   
}